const validationMessages = {
    firstName: "Vul een voornaam in.",
    phoneNumber: "Vul een telefoonnummer in.",
    reference: "Vul een referentie in.",
    mobileNumber: "Vul een mobiel telefoonnummer in.",
    question: "Vul hier uw vraag in.",
    company: "Vul hier uw bedrijfsnaam in.",
    fax: "Vul hier uw fax nummer in.",
    email: "Vul een geldig emailadres in",
    attachment_size: "Het bestand mag maximaal 10 MB zijn.",
    attachment_extension: "Het gekozen bestand kan niet geüpload worden. Alleen bestanden met de volgende extensies zijn toegestaan: jpg, jpeg, png, pdf",
    conditions: "Please read and accept the cancellation policy.",
    required: "Dit veld is verplicht",
    validPhoneNumber: "Vul een geldig telefoonnummer in.",
    maxChars: (max: number) => `Field should be maximum ${max} chars.`,
    minChars: (min: number) => `Field must be at least ${min} chars.`,
    equalToPassword: "Wachtwoorden komen niet overeen.",
    equalToEmail: "E-mailadressen komen niet overeen.",
    exactChars: (minMax: number) => `Vul ${minMax} tekens in.`,
    digitsOnly: "Dit veld mag alleen cijfers bevatten.",
    functionRequired: "Kies een optie",
    defaultOption: "Please select an option.",
    terms: "You have to agree to our terms and conditions.",
    maxDate: "Please select a date from the past."
}

export default validationMessages
